export default {
    select: {
        all: 'Tous',
        noOption: 'Aucune option.',
        noResults: 'Aucun résultat.',
        selected: 'sélectionnés',
    },
};
